// extracted by mini-css-extract-plugin
export default {"table_container":"keySkillsTable_table_container__xtM1f","table-row":"keySkillsTable_table-row__KAC4l"};